/**
 * ADA / Accessibility & Misc Fixes
 * Author: [CN]
 */

(function () {
  'use strict';

  /* -------------------------------
   * Utility functions
   * ------------------------------- */

  function $all(selector, context = document) {
    try {
      return Array.from(context.querySelectorAll(selector));
    } catch (err) {
      console.warn('ADA Fixer: invalid selector', selector, err);
      return [];
    }
  }

  function removeAttributes(el, attrs) {
    attrs.forEach(attr => el.removeAttribute(attr));
  }

  /* -------------------------------
   * Fix 1: Remove invalid aria-labels
   * ------------------------------- */
    function fixInvalidAriaLabels() {
        const elements = $all('[aria-label], [aria-labelledby]');
        elements.forEach(el => {
            const role = el.getAttribute('role') || '';
            const tag = el.tagName.toLowerCase();
            const hasTabIndexMinus1 = el.getAttribute('tabindex') === '-1';
            const hasOkeContainer = el.hasAttribute('data-oke-container');

            const disallowedRoles = ['generic', 'presentation', 'none', 'region'];
            const disallowedTags = ['div', 'span'];

            if (
            disallowedTags.includes(tag) &&
            (disallowedRoles.includes(role) || hasTabIndexMinus1 || hasOkeContainer)
            ) {
            console.info('ADA Fixer: removed invalid aria-label from', el);
            removeAttributes(el, ['aria-label', 'aria-labelledby']);
            }
        });
    }


  /* -------------------------------
   * Fix 2: Add alt text to <video> thumbnails
   * ------------------------------- */
  function fixVideoThumbnails() {
    $all('video > img').forEach(img => {
      if (!img.hasAttribute('alt') || /(picture|spacer)/i.test(img.alt)) {
        img.setAttribute('alt', 'Video thumbnail preview');
      }
    });
  }

  /* -------------------------------
   * Fix 3: Add "(Opens in a new window)" to external links
   * ------------------------------- */
  function fixExternalLinkTitles() {
    $all('a[target="_blank"]').forEach(link => {
      const ariaDescribedby = (link.getAttribute('aria-describedby') || '').trim();
      const existingAriaLabel = (link.getAttribute('aria-label') || '').trim();
      const title = (link.getAttribute('title') || '').trim();
      const visibleText = link.textContent.replace(/\s+/g, ' ').trim();
  
      // If aria-describedby already provides the new-window notice,
      // avoid adding duplicate accessibility information.
      if (ariaDescribedby) return;
  
      const windowNote = 'Opens in a new window';
  
      // Update title
      if (!title.toLowerCase().includes(windowNote.toLowerCase())) {
        const updatedTitle = title
          ? `${title} (${windowNote})`
          : windowNote;
  
        link.setAttribute('title', updatedTitle);
      }
  
      let ariaLabel = '';
  
      // WCAG 2.5.3:
      // Accessible name must include the visible label.
      if (visibleText) {
        ariaLabel = `${visibleText} (${windowNote})`;
      } else if (existingAriaLabel) {
        ariaLabel = existingAriaLabel
          .toLowerCase()
          .includes(windowNote.toLowerCase())
            ? existingAriaLabel
            : `${existingAriaLabel} (${windowNote})`;
      } else if (title) {
        ariaLabel = title
          .toLowerCase()
          .includes(windowNote.toLowerCase())
            ? title
            : `${title} (${windowNote})`;
      } else {
        ariaLabel = windowNote;
      }
  
      link.setAttribute('aria-label', ariaLabel);
    });
  }


  /* -------------------------------
   * Fix 4: Remove aria-labels from hidden links (tabindex=-1)
   * ------------------------------- */
  function fixHiddenLinks() {
    $all('a[tabindex="-1"][aria-label]').forEach(a => {
      a.removeAttribute('aria-label');
    });
  }

  /* -------------------------------
   * Fix 6: Store announcements in cookies
   * ------------------------------- */
  function saveAnnouncementsToCookie() {
    const annElements = $all('announcement-bar .announcement');
    const announcements = [];

    annElements.forEach(el => {
      const html = el.innerHTML.trim();
      if (html) announcements.push(html);
    });

    if (announcements.length > 0) {
      const data = JSON.stringify(announcements);
      const expires = new Date(Date.now() + 60 * 60 * 1000).toUTCString(); 
      document.cookie = `scarpa_announcements=${encodeURIComponent(
        data
      )}; expires=${expires}; path=/; domain=.scarpa.com; SameSite=Lax`;
    }
  }

  /* -------------------------------
   * Fix 7: Remove "fr" prefix for community URLs (Canada site)
   * ------------------------------- */
  function fixCommunityLinks() {
    if (window.location.href.includes('ca.scarpa.com')) {
      $all("a[href^='/fr/']").forEach(link => {
        if (link.href.includes('community') && link.href.includes('ca.scarpa.com')) {
          link.href = link.href.replace('/fr/', '/');
        }
      });
    }
  }

  /* -------------------------------
   * Run all fixes together
   * ------------------------------- */
  function runAccessibilityFixes() {
    fixInvalidAriaLabels();
    fixVideoThumbnails();
    fixExternalLinkTitles();
    fixHiddenLinks();
    fixCommunityLinks();
  }

  /* -------------------------------
   * Run non-DOM observer fixes
   * ------------------------------- */
  function runOneTimeFixes() {
    saveAnnouncementsToCookie();
  }

  /* -------------------------------
   * Observe DOM for dynamic changes
   * ------------------------------- */
  function observeDOM() {
    const observer = new MutationObserver(() => {
      runAccessibilityFixes();
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  /* -------------------------------
   * Init
   * ------------------------------- */
  document.addEventListener('DOMContentLoaded', () => {
    runAccessibilityFixes();
    runOneTimeFixes();
    observeDOM();
  });

})();
